import { render, staticRenderFns } from "./PFormSelectSearch.vue?vue&type=template&id=c27f46fe&scoped=true&"
import script from "./PFormSelectSearch.vue?vue&type=script&lang=ts&"
export * from "./PFormSelectSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PFormSelectSearch.vue?vue&type=style&index=0&id=c27f46fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27f46fe",
  null
  
)

export default component.exports